import { BROWSER_STORAGE_CLEANUP_DONE_KEY } from '../constants/storage-keys.constants';

export function clearLegacyBrowserStorage(): void {
  if (typeof window === 'undefined') return;
  if (localStorage.getItem(BROWSER_STORAGE_CLEANUP_DONE_KEY) === 'true') {
    return;
  }

  localStorage.clear();
  sessionStorage.clear();
  clearCookies();

  localStorage.setItem(BROWSER_STORAGE_CLEANUP_DONE_KEY, 'true');
}

function clearCookies(): void {
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const name = cookie.trim().split('=')[0];
    if (!name) continue;
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict`;
  }
}
